import React, {
  useCallback,
  useEffect,
  useRef,
  useMemo,
  useState,
} from "react";
import {
  FaFileCsv,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileVideo,
  FaRegSmile,
  FaShareAlt,
} from "react-icons/fa";
import { BeatLoader, FadeLoader } from "react-spinners";
import { IoChevronDownOutline } from "react-icons/io5";
import { Modal as ResponsiveModal } from "react-responsive-modal";

import {
  FaFilePdf,
  FaFileWord,
  FaFileImage,
  FaFileAlt,
  FaFile,
  FaUser,
} from "react-icons/fa";
import VoiceMessageBubble from "../../Group/ChatsSection/VoiceMessageBubble";
import {
  decryptMessage,
  decryptText,
  encrypt,
} from "../../../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import { toast } from "react-toastify";
import { deleteApiCaller, putApiCaller } from "../../../Libs/apiCaller";
import { useSelector } from "react-redux";
import Modal from "../../../Components/Modals/Modall";
import EmojiPicker from "emoji-picker-react";
import MapMessage from "../../../Components/MapMessage/MapMessage";
import { useTheme } from "../../../Context/ThemeContext";

const getFileExtension = (url) => {
  return url?.split(".").pop().toLowerCase();
};

const FileIcon = ({ url }) => {
  const ext = getFileExtension(url);

  const iconMap = {
    pdf: <FaFilePdf className="size-20 text-red-500" />,
    doc: <FaFileWord className="size-20 text-blue-600" />,
    docx: <FaFileWord className="size-20 text-blue-600" />,
    jpg: <FaFileImage className="size-20 text-green-500" />,
    png: <FaFileImage className="size-20 text-green-500" />,
    txt: <FaFileAlt className="size-20 text-gray-500" />,
    xls: <FaFileExcel className="size-20 text-green-600" />,
    xlsx: <FaFileExcel className="size-20 text-green-600" />,
    ppt: <FaFilePowerpoint className="size-20 text-orange-500" />,
    pptx: <FaFilePowerpoint className="size-20 text-orange-500" />,
    csv: <FaFileCsv className="size-20 text-blue-400" />,
  };

  return iconMap[ext] || <FaFile className="size-20 text-gray-400" />;
};

const linkify = (text) => {
  // Escape HTML to prevent script injection
  const escapeHtml = (str) =>
    str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  // Regex to detect URLs with or without protocol
  const urlPattern =
    /(?:https?:\/\/)?(?:www\.)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;

  // First escape the text
  const safeText = escapeHtml(text);

  // Then safely replace URLs
  return safeText.replace(urlPattern, (url) => {
    // Add https:// if no protocol is present
    const fullUrl = url.startsWith("http") ? url : `https://${url}`;
    return `<a href="${fullUrl}" class="underline" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
};

export default function ChatsSection({
  allMessages,
  setAllMessages,
  settings,
  getSecretKey,
  chatConversationId,
  isDecryptionLoading,
  setIsDecryptionLoading,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const { theme } = useTheme();
  const uid = localStorage.getItem("userId");
  const [messages, setMessages] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteMessageId, setDeleteMessageId] = useState(null);
  const [editingMessage, setEditingMessage] = useState(null);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [editedText, setEditedText] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);
  const dropdownRefs = useRef([]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefs.current[openDropdownIndex] &&
        !dropdownRefs.current[openDropdownIndex].contains(event.target)
      ) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownIndex]);
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateDivider = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const isDifferentDay = (current, previous) => {
    if (!previous) return true;
    const currentDate = new Date(current).toDateString();
    const previousDate = new Date(previous).toDateString();
    return currentDate !== previousDate;
  };


  const downloadFile = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = url;
    a.click();
  };

  function getContrastingTextColor(hex) {
    // Remove "#" if present
    hex = hex.replace("#", "");

    // Convert to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black for light backgrounds, white for dark backgrounds
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
  }

  const fgColor = useMemo(() => {
    const fgColor = settings?.chatColor
      ? `${getContrastingTextColor(settings?.chatColor)}`
      : "#fff";

    return `${fgColor}`;
  }, [settings]);

  const getAllMessages = useCallback(async () => {
    if (!getSecretKey) return;
    return await Promise.all(
      allMessages.map(async (msg) => {
        if (msg?.cipherText) {
          try {
            const decryptedText = await decryptMessage(
              msg?.cipherText,
              msg.iv,
              getSecretKey
            );

            return {
              ...msg,
              cipherText: decryptedText,
            };
          } catch (err) {
            console.error("Decryption failed:", err);
            return {
              ...msg,
              cipherText: "",
            };
          }
        }
        return msg;
      })
    );
  }, [allMessages, getSecretKey]); // dependencies

  useEffect(() => {
    if (getSecretKey) {
      (async () => {
        const messages = await getAllMessages();
        setIsDecryptionLoading(false);
        setMessages(messages);
      })();
    }
  }, [getSecretKey, getAllMessages]);

  const isCurrentUser = (id) => {
    return id === uid;
  };

  const handleCopy = async (chat) => {
    try {
      if (chat?.mediaUrl) {
        // for copy image
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = chat.mediaUrl;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        canvas.toBlob((blob) => {
          const item = new ClipboardItem({ "image/png": blob });
          navigator.clipboard.write([item]);
          toast.success("Image copied to clipboard!");
        });
      } else if (chat?.cipherText) {
        // for copy text
        await navigator.clipboard.writeText(chat.cipherText);
        toast.success("Text copied to clipboard!");
      }
    } catch (err) {
      toast.error("Failed to copy!");
    } finally {
      setOpenDropdownIndex(null);
    }
  };

  const deleteMessage = async () => {
    const endPoint = `messages/${deleteMessageId}`;
    const response = await deleteApiCaller(endPoint);
    if (response.status === 200) {
      setAllMessages(allMessages.filter((msg) => msg._id !== deleteMessageId));
      setDeleteModal(false);
      setDeleteMessageId(null);
      setOpenDropdownIndex(null);
      toast.success("Message deleted successfully!");
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const handleEdit = (message) => {
    setEditingMessage(message);
    setEditedText(message.cipherText || "");
    setEditModalOpen(true);
    setOpenDropdownIndex(null);
  };

  const containsLink = (message) => {
    // Match URLs with or without protocol (http/https)
    const urlRegex =
      /(?:https?:\/\/)?(?:www\.)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;
    const urls = message.match(urlRegex);
    return urls ? urls[0] : null;
  };

  const handleUpdateMessage = async (message, newText) => {
    setIsEditLoading(true);
    if (message.cipherText === editedText) {
      setIsEditLoading(false);
      setEditModalOpen(false);
      return;
    }
    try {
      const getKey = await decryptText(
        chatConversationId?.conversationId?.AESKeyOfUser,
        userInfo?.encryptedPrivateKey
      );
      const { iv, encryptedData } = await encrypt(newText, getKey);
      if (!iv && !encryptedData) {
        setIsEditLoading(false);
        return;
      }
      const endPoint = `messages/edit`;
      const payload = {
        messageId: message._id,
        iv: iv,
        cipherText: encryptedData,
        isLink: containsLink(newText) ? true : false,
      };
      const response = await putApiCaller(endPoint, payload);
      if (response.status === 200) {
        setAllMessages(
          allMessages.map((msg) =>
            msg._id === message._id
              ? {
                ...msg,
                iv: iv,
                isEdited: true,
                cipherText: encryptedData,
                messageType: containsLink(newText) ? "LINK" : "TEXT",
              }
              : msg
          )
        );
        setEditingMessage(null);
      } else {
        toast.error(response?.response?.data?.message || response.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
    } finally {
      setIsEditLoading(false);
      setEditModalOpen(false);
    }
  };

  const handleEmojiClick = (emojiObject) => {
    setEditedText((prev) => prev + emojiObject.emoji);
  };

  if (isDecryptionLoading) {
    return <></>;
  }

  return (
    <>
      {messages?.map((chat, index) => (
        <React.Fragment key={chat._id}>
          {isDifferentDay(chat.sentTime, messages[index - 1]?.sentTime) && (
            <div className="flex justify-center my-4">
              <span className="bg-zinc-100 text-zinc-500 text-xs px-3 py-1 rounded-full border border-zinc-200 shadow-sm">
                {formatDateDivider(chat.sentTime)}
              </span>
            </div>
          )}
          <div
            className={`chat w-full ${chat?.senderId?._id !== uid ? "chat-start" : "chat-end"
              }  ${allMessages[index + 1]?.senderId?._id === chat?.senderId?._id &&
              "my-1 p-0"
              }`}
          >
            <div
              className={`flex w-full max-w-3xl ${!isCurrentUser(chat?.senderId?._id)
                ? "flex-row gap-3 items-start"
                : "flex-col items-end"
                } gap-1`}
            >
              {/* {chat?.senderId?._id !== uid &&
            allMessages[index + 1]?.senderId?._id !== chat.senderId?._id ? (
              <div className="flex items-start gap-3">
                <img
                  src={
                    chat?.senderId?.avtarImage ||
                    chat?.senderId?.userImage ||
                    profile_Img
                  }
                  alt={chat?.senderId?.name}
                  className="w-8 h-8 rounded-full"
                />
              </div>
            ) : (
              <div className="w-8"></div>
            )} */}
              <div
                className={`flex ${chat.senderId?._id !== uid
                  ? "flex-col items-start"
                  : "flex-col items-end"
                  } gap-1`}
              >
                {/* {chat?.senderId?._id !== uid &&
                allMessages[index + 1]?.senderId?._id !== chat?.senderId?._id && (
                  <div className="text-xs w-auto text-[#7C7C7C] font-normal pb-2">
                    {chat?.senderId?.name}
                  </div>
                )} */}
                <div
                  style={{
                    ...(isCurrentUser(chat?.senderId?._id)
                      ? {
                        background: "linear-gradient(to right, rgb(37 99 235), rgb(79 70 229))",
                        color: "white"
                      }
                      : {}),
                  }}
                  className={`text-sm max-w-md relative rounded-[20px] break-all ${isCurrentUser(chat?.senderId?._id)
                    ? "text-white rounded-br-sm shadow-md"
                    : "bg-white dark:bg-slate-800 border-zinc-100 dark:border-slate-700 text-zinc-800 dark:text-white rounded-bl-sm shadow-sm"
                    } ${chat?.mediaUrl && chat?.mediaId?.fileType === "image"
                      ? chat.cipherText
                        ? "p-1"
                        : "p-0"
                      : "px-3 py-3 pr-6"
                    }`}
                >
                  <div
                    className={`absolute z-10 ${chat?.mediaUrl && chat?.mediaId?.fileType === "image"
                      ? "top-2 right-2" // or custom positions for image
                      : "top-1 right-1 mt-1"
                      }`}
                    ref={(el) => (dropdownRefs.current[chat._id] = el)}
                  >
                    {(chat?.mediaId?.fileType === "image" ||
                      chat?.cipherText ||
                      chat.senderId?._id === uid) &&
                      chat?.messageType !== "LOCATION" &&
                      !chat.loading && (
                        <div className="group absolute top-0 right-0 p-1 pointer-events-auto z-20">
                          <div
                            className={`${chat.mediaUrl &&
                              chat?.mediaId?.fileType === "image" &&
                              "bg-black/20 rounded-full p-1 transition-all group-hover:bg-black cursor-pointer"
                              }`}
                            onClick={() =>
                              setOpenDropdownIndex(
                                openDropdownIndex === chat._id ? null : chat._id
                              )
                            }
                          >
                            <IoChevronDownOutline className="text-white cursor-pointer" />
                          </div>
                        </div>
                      )}
                    {openDropdownIndex === chat._id &&
                      !chat.loading &&
                      chat?.messageType !== "LOCATION" &&
                      (chat?.mediaId?.fileType === "image" ||
                        chat?.mediaId?.fileType === "document" ||
                        chat?.mediaId?.fileType === "audio" || // Added audio here
                        chat?.cipherText ||
                        chat.senderId?._id === uid) && (
                        <div
                          className={`absolute right-[-10px] w-35 bg-white shadow-lg rounded-md z-30 border ${chat?.mediaId?.fileType === "document" ||
                            chat?.mediaId?.fileType === "audio" ||
                            chat?.mediaId?.fileType === "video"
                            ? "top-0"
                            : chat?.senderId?._id === uid && index === 0
                              ? "top-[-85px]"
                              : "top-[10px]"
                            }`}
                        >
                          <ul className="py-1 text-sm text-gray-700">
                            {(chat?.mediaId?.fileType === "image" ||
                              chat?.cipherText) &&
                              chat.mediaId.fileType !== "document" &&
                              chat.mediaId.fileType !== "audio" &&
                              chat.mediaId.fileType !== "video" && (
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => handleCopy(chat)}
                                >
                                  Copy
                                </li>
                              )}
                            {chat?.senderId?._id === uid && (
                              <>
                                {chat?.cipherText &&
                                  chat?.messageType !== "CONTACT" && (
                                    <li
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      onClick={() => handleEdit(chat)}
                                    >
                                      Edit
                                    </li>
                                  )}
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    setDeleteModal(true);
                                    setDeleteMessageId(chat._id);
                                  }}
                                >
                                  Delete
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                  {chat?.mediaId?.fileType === "document" && (
                    <div
                      onClick={() =>
                        !chat.loading &&
                        // !isCurrentUser(chat?.senderId?._id) &&
                        downloadFile(chat.mediaUrl)
                      }
                      className={`${chat.loading ? "cursor-progress" : "cursor-pointer"
                        } relative flex flex-col items-center gap-2 pt-5`}
                    >
                      <div className="flex items-center justify-center bg-white w-full py-5 rounded-lg relative overflow-hidden">
                        <FileIcon url={chat.mediaId.fileUrl} />
                        {chat.loading && (
                          <div className="absolute inset-0 bg-black/40 z-10 flex justify-center items-center">
                            <FadeLoader
                              color="#7104F8"
                              loading={true}
                              size={12}
                            />
                          </div>
                        )}
                      </div>
                      <div className="whitespace-pre-line max-w-50 truncate">
                        {
                          chat?.mediaId?.fileUrl?.split?.("/")?.[
                          chat?.mediaId?.fileUrl?.split("/")?.length - 1
                          ]
                        }
                      </div>
                    </div>
                  )}
                  {chat?.mediaId?.fileType === "video" && (
                    <div
                      onClick={() =>
                        !chat.loading &&
                        // !isCurrentUser(chat?.senderId?._id) &&
                        downloadFile(chat.mediaUrl)
                      }
                      className={`${chat.loading ? "cursor-progress" : "cursor-pointer"
                        } relative flex flex-col items-center gap-2 pt-5`}
                    >
                      <div className="flex items-center justify-center bg-white w-full py-5 rounded-lg relative overflow-hidden">
                        <FaFileVideo className="size-20 text-purple-500" />
                        {chat.loading && (
                          <div className="absolute inset-0 bg-black/40 z-10 flex justify-center items-center">
                            <FadeLoader
                              color="#7104F8"
                              loading={true}
                              size={12}
                            />
                          </div>
                        )}
                      </div>
                      {/* <div className="whitespace-pre-line max-w-50 truncate">
                          {
                            chat?.mediaId?.fileUrl?.split?.("/")?.[
                              chat?.mediaId?.fileUrl?.split("/")?.length - 1
                            ]
                          }
                        </div> */}
                    </div>
                  )}
                  {chat.mediaUrl && chat?.mediaId?.fileType === "audio" && (
                    <div className="relative">
                      <VoiceMessageBubble
                        url={chat.mediaUrl}
                        disabled={chat.loading}
                      />
                    </div>
                  )}
                  {chat.mediaUrl && chat?.mediaId?.fileType === "image" && (
                    <div className="relative w-[400px] min-w-[400px] h-[500px] min-h-[500px] max-h-[500px] flex justify-center items-center rounded-[16px] bg-[#f0f0f0] dark:bg-gray-800 group">
                      <div
                        className={`relative w-full h-full rounded-[16px] overflow-hidden ${!chat?.cipherText && !isCurrentUser(chat?.senderId?._id)
                          ? ""
                          : "rounded-br-none"
                          }`}
                      >
                        <img
                          onClick={() =>
                            !chat.loading &&
                            // !isCurrentUser(chat?.senderId?._id) &&
                            downloadFile(chat.mediaUrl)
                          }
                          src={chat.mediaUrl}
                          alt="Card Media"
                          className="w-full h-full object-cover cursor-pointer rounded-xl rounded-b-none"
                        />
                        {chat.loading && (
                          <div className="absolute inset-0 bg-black/40 z-10 flex justify-center items-center">
                            <FadeLoader
                              color="#7104F8"
                              loading={true}
                              size={12}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {chat?.messageType === "LOCATION" && (
                    <MapMessage text={chat?.cipherText} />
                  )}
                  {chat?.messageType === "CONTACT" && (
                    <div className="flex items-center gap-3 p-2 rounded-lg">
                      <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
                        {chat?.sharedContact?.avtarImage ||
                          chat?.sharedContact?.userImage ? (
                          <img
                            src={
                              chat?.sharedContact?.avtarImage ||
                              chat?.sharedContact?.userImage
                            }
                            alt="contact"
                            className="w-full h-full object-cover rounded-full"
                          />
                        ) : (
                          <FaUser className="text-gray-500 text-xl" />
                        )}
                      </div>
                      <div className="flex flex-col">
                        <div className="font-medium">
                          {chat?.sharedContact?.name}
                        </div>
                        <div className="text-sm">
                          {chat?.sharedContact?.phone}
                        </div>
                      </div>
                    </div>
                  )}
                  {chat?.messageType !== "LOCATION" && chat.cipherText && (
                    <div
                      className={`whitespace-pre-wrap break-words break-normal max-w-[400px] ${chat?.senderId?._id === uid ? "text-left" : "text-left"
                        }`}
                      style={{
                        wordBreak: "normal",
                        overflowWrap: "break-word",
                      }}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: linkify(chat.cipherText),
                        }}
                      />
                      <span
                        className={`text-[10px] ml-2 opacity-70 inline-block align-bottom ${isCurrentUser(chat?.senderId?._id)
                          ? "text-white"
                          : "text-zinc-500"
                          }`}
                      >
                        {formatTime(chat.sentTime)}
                      </span>
                    </div>
                  )}
                  {chat?.isEdited && (
                    <p
                      className={`${chat?.senderId?._id === uid
                        ? "text-white text-right font-normal"
                        : "text-black text-right pr-2.5 font-normal"
                        } text-xs pt-2 mr-[-0px] mb-0.5`}
                    >
                      Edited
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
      <Modal
        isOpen={deleteModal}
        onClose={() => {
          setDeleteMessageId(null);
          setDeleteModal(false);
        }}
        onConfirm={deleteMessage}
        description="Are you sure you want to delete this message?"
        title="Delete Message"
      />
      <ResponsiveModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        center
        closeIcon={false}
        classNames={{
          modal: "custom-modal",
          overlay: "custom-overlay",
        }}
        styles={{
          modal: {
            padding: 2,
            width: "100%",
            maxWidth: "35rem", // ~512px
            borderRadius: "0.75rem", // rounded-xl
          },
        }}
      >
        {/* Header */}
        <div className="flex justify-between items-center border-b p-4">
          <h2 className="text-lg font-semibold text-gray-800">Edit Message</h2>
        </div>

        {/* Message Bubble Preview */}
        <div className="p-4 overflow-y-auto flex-1 flex justify-center items-center ">
          <div className=" bg-[#7104F8] text-white px-4 py-3 rounded-lg max-w-sm w-full break-words whitespace-pre-wrap text-sm shadow">
            {editedText || "Your message preview will appear here..."}
          </div>
        </div>

        {/* Footer */}
        {showEmojiPicker && (
          <div
            ref={emojiPickerRef}
            className="absolute top-0 right-15 bg-white shadow-lg rounded-md"
          >
            <EmojiPicker theme={theme} onEmojiClick={handleEmojiClick} />
          </div>
        )}
        <div className="border-t p-3 flex items-end gap-2">
          <textarea
            rows={4}
            className="flex-1 resize-none px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7104F8] text-sm transition-all duration-150 max-h-[200px]"
            placeholder="Edit your message..."
            value={editedText}
            onChange={(e) => {
              setEditedText(e.target.value);
              const el = e.target;
              el.style.height = "auto";
              const maxHeight = 200;
              const scrollHeight = el.scrollHeight;
              el.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
              el.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
            }}
          />
          <div className="flex flex-col items-center gap-2">
            <button
              type="button"
              className="p-2 text-gray-500 hover:text-gray-900"
              onClick={() => setShowEmojiPicker((prev) => !prev)}
            >
              <FaRegSmile className="w-6 h-6" />
            </button>
            <button
              onClick={() => handleUpdateMessage(editingMessage, editedText)}
              disabled={isEditLoading || !editedText.trim()}
              className="bg-[#7104F8] hover:bg-purple-700 text-white px-4 py-2 rounded-md text-sm disabled:opacity-50"
            >
              {isEditLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </ResponsiveModal>
    </>
  );
}
